<script setup>
import { useMediaQuery } from '@vueuse/core';
import useParallax from '@/composables/useParallax';
import useVisibility from '@/composables/useVisibility';
defineProps({
  positionVertical: {
    type: String,
    default: () => 'none',
  },
  positionHorizontal: {
    type: String,
    default: () => 'none',
  },
});

const isMobile = useMediaQuery('(max-width: 767px)');
const { x, y } = useParallax(150);
const { target: circleRef, isVisible } = useVisibility();
</script>
<template>
  <div
    ref="circleRef"
    :class="[
      'section__circle',
      `section__circle--${positionVertical}-${positionHorizontal}`,
    ]"
    :style="{
      transform:
        isVisible && !isMobile
          ? `translate(${x}px, ${y}px)`
          : 'translate(0, 0)',
    }"
  >
    <img
      class="section__circle-image"
      src="/images/style/ellipse.svg"
      alt="elipse"
      width="1017"
      height="1017"
    />
  </div>
</template>
<style scoped lang="scss">
.section__circle {
  position: absolute;
  border-radius: 50%;
  z-index: 1;
  width: 1017px;
  height: 1017px;
  &--none-none {
    display: none;
  }
  &--top-middle {
    left: 0;
    right: 0;
    margin: 0 auto;
    top: -637px;
  }
  &--top-left {
    left: -508px;
    top: -637px;
  }
  &--top-right {
    right: -508px;
    top: -637px;
  }
  &--middle-right {
    right: -508px;
    top: calc(50% - 508px);
  }
  &--middle-left {
    left: -508px;
    top: calc(50% - 508px);
  }
  &-image {
    width: 100%;
    height: 100%;
  }
}
</style>
